import { useState,useEffect } from "react"
import axios from "axios"
export default function Usuarios({log}){
    const columnas=["Nick","Nombre","1º Apellido","2º Apellido","Email","Teléfono","Administrador","Estado"]
    const [usuarios,setUsuarios]=useState([])
    const [accion,setAccion]=useState("")
    const [abiertos,setAbiertos]=useState(true)
    const [cerrados,setCerrados]=useState(true)
    const [usuario,setUsuario]=useState(null)
    useEffect(()=>{
        axios.get("https://www.asinova.es/webapi/api/Usuarios/abierto-cerrado")
            .then(res=>setUsuarios(res.data.sort((x,y)=>x.nick.localeCompare(y.nick))))
    },[])
    return(
        <>
            <h1 style={{textAlign:'center',margin:'1rem'}}>USUARIOS</h1>
            <div className='flex' style={{justifyContent:'center',width:'fit-content',margin:'0 auto'}}>
                <div style={{margin:'0.5rem 1rem',width:'fit-content',marginTop:'0'}}>
                    <input type="checkbox" id={"abiertos"} name={"abiertos"} style={{margin:'0'}} checked={abiertos} onChange={()=>{setAbiertos(!abiertos)}}/>
                    <label for={"abiertos"} style={{margin:'0 0.5rem'}}>Operativos</label>
                </div>
                <div style={{margin:'0.5rem 1rem',width:'fit-content',marginTop:'0'}}>
                    <input type="checkbox" id={"cerrados"} name={"cerrados"} style={{margin:'0'}} checked={cerrados} onChange={()=>{setCerrados(!cerrados)}}/>
                    <label for={"cerrados"} style={{margin:'0 0.5rem'}}>No operativos</label>
                </div>
            </div>
            <table style={{margin:'0rem auto 1rem auto',borderRadius:'5px'}}>
                <tr>
                    {columnas.map((col,index)=>(
                        <th key={index}>{col}</th>
                    ))}
                </tr>
                {usuarios.filter(x=>(x.operativo && abiertos) || (!x.operativo && cerrados)).map(x=>(
                    <tr style={{cursor:'pointer'}} onClick={()=>{setUsuario(x.id!=log.id && usuario==null?x:null);setAccion(x.id==log.id || accion=="put-del"?"":"put-del")}}  className={x.id==log.id?'log':usuario!=null && x.id==usuario.id?'seleccion':x.operativo?"":"cerrado"}><td>{x.nick}</td><td>{x.nombre}</td><td>{x.apellido1}</td><td>{x.apellido2}</td><td>{x.email}</td><td>{x.telefono}</td><td>{x.administrador?"Sí":"No"}</td><td>{x.operativo?"Operativo":"No operativo"}</td></tr>
                ))}
            </table>
            {accion!="" && usuario!=null && log.id!=usuario.id?
            <div className="ventana-emergente">
                <a className="btn-form" onClick={()=>{setUsuario(null);setAccion("")}} style={{padding:'0.1rem 0.45rem',marginTop:'1rem',float:'right'}}>X</a>
                {accion=="put-del"?
                <div className='flex' style={{marginRight:'3rem',marginTop:'1rem'}}>
                    <a className='btn-form' style={{marginRight:'1rem'}} onClick={()=>{
                        const nuevo={
                            id:usuario.id,
                            nombre:usuario.nombre,
                            apellido1:usuario.apellido1,
                            apellido2:usuario.apellido2,
                            nick:usuario.nick,
                            clave:usuario.clave,
                            email:usuario.email,
                            telefono:usuario.telefono,
                            administrador:usuario.administrador,
                            operativo:!usuario.operativo,
                            perfil:usuario.perfil
                        }
                        axios.put("https://www.asinova.es/webapi/api/Usuarios",nuevo).then(()=>{
                            let users=usuarios.filter(x=>x.id!=usuario.id)
                            users.push(nuevo)
                            setUsuarios(users.sort((x,y)=>x.nick.localeCompare(y.nick)))
                        })
                    }}>{usuario.operativo?"Dar de baja":"Dar de alta"}</a>
                    <a className='btn-form' style={{marginRight:'1rem'}} onClick={()=>{
                        const nuevo={
                            id:usuario.id,
                            nombre:usuario.nombre,
                            apellido1:usuario.apellido1,
                            apellido2:usuario.apellido2,
                            nick:usuario.nick,
                            clave:usuario.clave,
                            email:usuario.email,
                            telefono:usuario.telefono,
                            administrador:!usuario.administrador,
                            operativo:usuario.operativo,
                            perfil:usuario.perfil
                        }
                        axios.put("https://www.asinova.es/webapi/api/Usuarios",nuevo).then(()=>{
                            let users=usuarios.filter(x=>x.id!=usuario.id)
                            users.push(nuevo)
                            setUsuarios(users.sort((x,y)=>x.nick.localeCompare(y.nick)))
                        })
                    }}>{usuario.administrador?"No administrador":"Administrador"}</a>
                    <a className='btn-form' onClick={()=>{
                        axios.delete(`https://www.asinova.es/webapi/api/Usuarios/${usuario.id}`)
                        .then(()=>{
                            setUsuarios(usuarios.filter(x=>x.id!=usuario.id));
                            setAccion("");
                            setUsuario(null);
                        });
                    }}>Eliminar</a>
                </div>
                :null}
            </div>
            :null}
        </>
    )
}